import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { map, Observable, shareReplay } from "rxjs";
import { LightGallerySettings } from "lightgallery/lg-settings";
import { LightGallery } from "lightgallery/lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import lgAutoplay from "lightgallery/plugins/autoplay";
import { LoginComponent } from "../../../auth/components/login/login.component";
import { AuthService } from "src/app/core/services/auth.service";
import { DataService } from 'src/app/core/services/data.service';
import { BeforeOpenDetail, BeforeSlideDetail, InitDetail } from "lightgallery/lg-events";
import { LightGalleryService } from '../../../core/services/lightGallery.service';
import { ChangeDetectorRef } from '@angular/core';
import { EventService } from "src/app/core/services/event.service";
import { HttpClient } from "@angular/common/http";
import { GridGalleryItemComponent } from "./grid-gallery-item/grid-gallery-item.component";
import { GalleryItem } from 'lightgallery/lg-utils';
import { FileDownloadService } from "src/app/core/services/filedownload.service";


@Component({
  selector: "app-grid-gallery",
  templateUrl: "./grid-gallery.component.html",
  providers: [LoginComponent],
  // changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class GridGalleryComponent implements OnInit {
  // @ViewChild(GridGalleryItemComponent)
  // private gridItemComponent!: GridGalleryItemComponent;
  @Input() images!: any;
  @Input() isAnnonymous!: any;
  @Input() totalImages!: any;
  @Input() reloadGallery!: any;
  @Input() cols: number = 4;
  @Input("cols.xs") cols_xs: number = 3;
  @Input("cols.sm") cols_sm: number = 3;
  @Input("cols.md") cols_md: number = 3;
  @Input("cols.lg") cols_lg: number = 4;
  @Input("cols.xl") cols_xl: number = 6;
  @Input() rowHeight: number = 1;
  @Input() gutterSize: number = 1;
  @Input() eventId: any;
  @Input() userId: any;
  col: any;
  dataArray: any;
  currentPicture: any = 0;
  prevPicture: any = 0;
  labelId: any;
  isDeleteEnabled: boolean = false;
  settings: LightGallerySettings = {
    counter: true,
    controls: true,
    download: true,
    toggleThumb: true,
    // animateThumb: true,
    //rotate: true,
    plugins: [lgZoom, lgAutoplay, lgVideo],
    videojs: false,
    autoplayVideoOnSlide: true,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'B4CC75A2-F1B7-4E3F-A404-A011D11D0181',
    loop: false,
    // selector: ".enable-thumb",
    hideBarsDelay: 0,
    // mode: 'lg-zoom-in-big',
    // numberOfSlideItemsInDom: 3,
    // easing: 'easy',
    //   speed: 900,
    preload: 5,
    //  isMobile:true,
    videojsOptions: {
      height: 720,
      autoplay: true
    },
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      toggleThumb: true,
      videojs: false,
    },
    allowMediaOverlap: true,
    closeOnTap: false
  };

  lightGallery!: LightGallery;
  needRefresh = false;
  // detail:any;
  constructor(private breakpointObserver: BreakpointObserver, private fileDownloadService: FileDownloadService,

    public loginComponent: LoginComponent, private http: HttpClient,
    private authService: AuthService, private eventService: EventService,
    private dataService: DataService, private el: ElementRef, private lightGalleryService: LightGalleryService,
    private cdr: ChangeDetectorRef
  ) {
    this.dataArray = this.dataService.getArray();
    this.images = [];

    this.isDesktop$.subscribe((data) => {
      if (data) {
        this.col = 4;
      }
    });
    this.istablet$.subscribe((data) => {
      if (data) {
        this.col = 4;
      }
    });
    this.isHandset$.subscribe((data) => {
      if (data) {
        this.col = 3;
      }
    });

    this.isXLarge$.subscribe((data) => {
      if (data) {
        this.col = 5;
      }
    });
  }

  onInit = (detail: InitDetail): void => {
    this.lightGallery = detail.instance;
    this.lightGallery.refresh();
    this.lightGalleryService.setLightGalleryInstance(this.lightGallery); // Store the instance in the service
    // console.log(this.lightGallery); //__CONSOLE_LOG__
  };

  callOnInitAgain() {
    this.lightGallery.refresh();
    this.lightGallery.openGallery();
  }

  refreshComponent() {
    // Update component data or properties
    // Trigger change detection
    this.cdr.detectChanges();
    this.lightGallery.refresh();
  }

  // onBeforeSlide = (detail: BeforeSlideDetail): void => {
  //   const { index, prevIndex } = detail;
  //   console.log(index, prevIndex);
  //   console.log('before slide')
  //   //this.lightGallery.refresh();
  //   //this.lightGallery.updateSlides(this.images,this.lightGallery.index);
  // };

  onAfterAppendSlide = (detail: any): void => {
    //  console.log('append called');
    this.lightGallery.refresh();

  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (!changes['images']?.firstChange) {
  //     this.needRefresh = true;
  //   }
  // }


  // handleThumbnailClick(id: any): void {
  //   console.log(document.getElementById('lightgallery')?.classList);

  //   if (this.isDeleteEnabled) {
  //     document.getElementById('lightgallery')?.classList.add("disable-thumb");
  //   }
  //   else {
  //     document.getElementById('lightgallery')?.classList.remove("disable-thumb");
  //   }
  // }

  addImage = (lightGallery: LightGallery) => {
    // console.log('add image:'); //__CONSOLE_LOG__
    this.dataArray = this.dataService.getArray();
    const galleryItems = this.dataArray.map((src: any, index: number) => ({
      src: src.fileUrl,           // URL of the full-size image
      downloadUrl: src.downloadUrl,
      thumb: src.thumbUrl,         // URL of the thumbnail image (same as src in this example)
      alt: src.mime_type, // Subtitle or caption for the image
      // Add any other properties you need for your specific use case
    }));

    this.images = [
      ...this.images,
      galleryItems
    ];
    // console.log(this.images);
    this.lightGallery = lightGallery;
    this.lightGallery.updateSlides(galleryItems, this.lightGallery.index);
    this.needRefresh = true;

  };

  updateGallery(lightGallery: LightGallery): void {
    this.dataArray = this.dataService.getArray();

    const galleryItems = this.dataArray.map((src: any, index: number) => ({
      src: src.fileUrl,
      downloadUrl: src.downloadUrl,
      thumb: src.thumbUrl,
      alt: src.mime_type,
    }));

    this.images = [
      ...this.images,
      galleryItems
    ];

    this.lightGallery = lightGallery;
    this.lightGallery.refresh(galleryItems);
  }

  // trackByFn(index: number, item: any): number {
  //   console.log({ item });

  //   return item.id; // Replace 'id' with the unique identifier property of your item
  // }


  onAfterSlide = (detail: any): void => {
    this.currentPicture = this.images[detail.index].id;
    // console.log('after slide'); //__CONSOLE_LOG__


    if (this.isAnnonymous) {
      if (this.images.indexOf(this.images[detail.index]) + 1 === 51 || this.images.indexOf(this.images[detail.index]) == this.totalImages) {
        if (confirm('Login to view All')) {
          // Save it!
          this.signUpWithGoogle();
        } else {
          // Do nothing!
        }
      }
    }
    //this.lightGallery.refresh();

  }

  onAfterClose = (detail: any): void => {
    this.scrollToItem();
    // console.log('after close'); //__CONSOLE_LOG__

    this.lightGallery.refresh();
  }


  removeItemsByCondition() {
    this.images = this.images.filter((item: { selected: boolean, isDeleted: boolean }) => item.isDeleted === false);
    this.dataService.totalImages = this.images.length;
  }

  scrollToItem() {
    setTimeout(() => {
      const element = document.getElementById(this.currentPicture);
      element?.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }


  ngAfterViewChecked(): void {
    // this.lightGallery.refresh();
    if (this.needRefresh) {
      this.lightGallery.refresh();
      // console.log(this.lightGallery);
      //this.lightGallery.refresh(this.images);
      //this.lightGallery.openGallery();
      this.needRefresh = false;
    }
    this.lightGallery.$toolbar.find('.lg-counter-all').first().html(this.dataService.totalImages);

  }

  clearSelections() {
    this.isDeleteEnabled = !this.isDeleteEnabled;
    this.removeItemsByCondition();
    this.images.forEach((image: { selected: boolean, isDeleted: boolean }) => image.selected === false && image.isDeleted === false);
    this.lightGallery.refresh();
    //setTimeout(async () => {window.location.reload() }, 4000);
  }

  UncheckAll() {
    this.isDeleteEnabled = false;
    this.images.forEach((image: { selected: boolean; }) => image.selected = false);
    document.getElementById('lightgallery')?.classList.remove("disable-thumb");
  }

  enableCheckBox(): void {
    this.isDeleteEnabled = !this.isDeleteEnabled;
    if (this.isDeleteEnabled) {
      document.getElementById('lightgallery')?.classList.add("disable-thumb");
    }
    else {
      //  document.getElementById('lightgallery')?.classList.remove("disable-thumb");
      this.clearSelections();
    }
  }

  selectAll() {
    if (this.images.every((item: { selected: boolean; }) => (item.selected == true))) {
      this.images.forEach((item: { selected: boolean; }) => (item.selected = false));
    }
    else {
      this.images.forEach((item: { selected: boolean; }) => (item.selected = true));
    }

    // this.updateSelectedItems();
  }

  async getSelectedItems() {
    this.eventId = this.dataService.eventId;
    this.userId = this.dataService.userId;
    // console.log(this.images); //__CONSOLE_LOG__
    let file_ids: number[] = [];
    let selectedFiles = this.images.filter((item: { selected: boolean }) => item.selected);
    // selectedFiles.forEach((element: { id: number; user_id:any}) => file_ids.push(parseInt(element.id.toString())));
    selectedFiles = selectedFiles.filter((item: { user_id: any }) => item.user_id === this.userId);
    selectedFiles.forEach((element: { id: number; }) => file_ids.push(parseInt(element.id.toString())));
    // console.log(file_ids); //__CONSOLE_LOG__

    // console.log(this.eventId, this.userId); //__CONSOLE_LOG__
    await this.deleteMedia(this.eventId, this.userId, file_ids);
    this.dataService.setVariable(true);
    for (let index = 0; index < this.images.length; index++) {
      const element = this.images[index];
      // console.log(element); //__CONSOLE_LOG__
      if (file_ids.includes(parseInt(element.id.toString()))) {
        // console.log('deleted id:', element.id); //__CONSOLE_LOG__
        element.isDeleted = true;
      }
    }
    // this.images.forEach((element: { id: number; isDeleted: boolean; }) => {
    //   if (file_ids.find(id => id === element.id)) {
    //     console.log('deleted id:', element.id);
    //     element.isDeleted = true;
    //   }
    // });

    this.clearSelections();
  }

  downloadFileFromS3(url: string, fileName: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe((data: Blob) => {
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(data);
      downloadLink.download = fileName;//this.getFileNameFromUrl(url); // Extract filename from the URL
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  }

  private getFileNameFromUrl(url: string): string {
    // Extract filename from the S3 URL
    const parts = url.split('/');
    // console.log(parts) //__CONSOLE_LOG__
    const imagePart = parts[parts.length - 1];
    const imageName = imagePart.split('?')[0];
    return imageName;
  }

  downloadSelected(eventName: any) {
    let downloadUrls: any[] = [];
    let altUrls: any[] = [];
    let fileNames: any[] = [];
    let selectedDownload = this.images.filter((item: { selected: any; }) => item.selected);
    if (selectedDownload.length > 1) {
      selectedDownload.forEach((item: { fileName: any; downloadUrl: any; fileUrl: any }) => {
        //  this.downloadFileFromS3(item.downloadUrl, item.fileName);
        downloadUrls.push(item.downloadUrl);
        fileNames.push(item.fileName);
        altUrls.push(item.fileUrl);
      });
      this.fileDownloadService.downloadFiles(downloadUrls, eventName.toString(), altUrls, fileNames);
    }
    else {
      selectedDownload.forEach((item: { fileName: any; downloadUrl: any; fileUrl: any }) => {
        this.downloadFileFromS3(item.downloadUrl, item.fileName);
      });
    }


    this.UncheckAll();
  }

  async deleteMedia(eventId: any, userId: any, fileIds: number[]) {
    (await this.eventService.deleteMedia(eventId, userId, fileIds)).subscribe({
      next: (res) => {
        if (res) {
          // console.log("delete successful") //__CONSOLE_LOG__
        } else {
          // console.log("error"); //__CONSOLE_LOG__
        }
      },
      error: (err) => {
        // console.error(err); //__CONSOLE_LOG__
      },
    });
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  istablet$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Tablet)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  isDesktop$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Web)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  isXLarge$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.XLarge)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  ngOnInit() {
    // console.log(2); //__CONSOLE_LOG__
    //this.labelId  = 'cb' + this.im.id;
    if (this.isAnnonymous) {
      this.col = 2;
      // console.log(this.images);

    }
  }



  signUpWithGoogle() {
    this.authService
      .anonymousToGoogle()
      .then((res) => {
        // this.router.navigateByUrl("/auth/login");
        this.loginComponent.signUpWithGoogle();
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }
}
